import React from 'react';
import Button from '../../../../shared/components/buttons/Button';
import { ILoginButton } from './interface';

function LoginButton(props: ILoginButton) {
  return (
    <Button.Default type={props.type} onClick={props.onClick} width="8rem">
      {props.children}
    </Button.Default>
  );
}

export default LoginButton;
